'use client'
import { Add } from '@mui/icons-material'
import { Box, Button, Stack, Skeleton } from '@mui/material'
import { FormFieldType } from '@/types'
import { Dispatch, SetStateAction, memo, useCallback } from 'react'
import { useTranslations } from 'next-intl'
import { v4 as uuidv4 } from 'uuid'
import { FieldType } from '@/enum'
import FieldList from './FieldList'

type FormSectionBodyProps = {
  fields: FormFieldType[]
  setFields: Dispatch<SetStateAction<FormFieldType[]>>
  isDefaultSection?: boolean
  isSectionVisible?: boolean
}

const FormSectionBody = memo(({ fields, setFields, isDefaultSection, isSectionVisible = true }: FormSectionBodyProps) => {
  const t = useTranslations('HOMEPAGE')

  const addFieldClickHandler = useCallback(() => {
    const newField: FormFieldType = {
      id: uuidv4(),
      label: '',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: false,
      identifier: '',
      placeholder: t('NEW_FIELD_VALUE_PLACEHOLDER'),
    }
    setFields((prev) => [...prev, newField])
  }, [setFields, t])

  return (
    <Box
      sx={{
        opacity: isSectionVisible ? 1 : 0.3,
        transition: 'opacity 0.2s ease-in-out',
        pointerEvents: isSectionVisible ? 'auto' : 'none',
      }}
    >
      {fields && fields.length > 0 ? (
        <FieldList fields={fields} setFields={setFields} />
      ) : isDefaultSection ? (
        <Stack spacing={2}>
          {Array.from({ length: 20 }, (_, index) => (
            <Skeleton key={index} variant="rounded" width="100%" height={40} />
          ))}
        </Stack>
      ) : null}
      <Button variant="outlined" onClick={addFieldClickHandler} startIcon={<Add />} size="small">
        {t('ADD_NEW_FIELD')}
      </Button>
    </Box>
  )
})

FormSectionBody.displayName = 'FormSectionBody'

export default FormSectionBody
